import { render, staticRenderFns } from "./video-stat.vue?vue&type=template&id=fa37e5fc&scoped=true"
import script from "./video-stat.vue?vue&type=script&lang=js"
export * from "./video-stat.vue?vue&type=script&lang=js"
import style0 from "./video-stat.vue?vue&type=style&index=0&id=fa37e5fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa37e5fc",
  null
  
)

export default component.exports